/**
 * Fired by any guest-side action that creates or mutates an activity
 * (order, housekeeping/maintenance/service request, laundry, reservation).
 * `ActiveUpdates` listens for this to refresh without waiting on SignalR,
 * since same-device creates don't receive a hub echo.
 */
export const ACTIVITY_CHANGED_EVENT = 'gcxp:activity-changed';

export function emitActivityChanged(): void {
  window.dispatchEvent(new CustomEvent(ACTIVITY_CHANGED_EVENT));
}
